module.exports = __webpack_public_path__ + "img/logo-administrador.5c2d7336.png";